import styled from 'styled-components';

import { mq, color, space } from '../../../../stylesheets';

export const FilterWrapper = styled.div`
  height: 100%;
  width: 100%;
  margin: 0 auto;
  padding: ${space(['m', 's'])};

  ${mq('m')} {
    padding: ${space(['l', 'm'])};
    margin-top: ${space('l')};
  }
`;

export const AddressFilterWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: ${space('s')};

  ${mq('m')} {
    grid-column-gap: ${space('xxs')};
    grid-template-columns: 3fr 1fr;
  }

  & > div:only-child {
    grid-column: 1 / -1;
  }
`;

export const Tag = styled.button<{ $active?: boolean }>`
  border: 2px solid ${color('primary')};
  padding: 0 ${space('s')};
  display: flex;
  align-items: center;
  height: 50px;
  background: ${props => (props.$active ? color('primary') : color('neutral', 10))};
  color: ${props => (props.$active ? color('neutral', 10) : color('primary'))};
  transition: all 0.2s ease-in-out;
  box-shadow: 0 0 0px 0px ${color('primary')};

  &:hover {
    box-shadow: 0 0 5px 2px ${color('primary', 20)};
  }

  &[disabled] {
    cursor: not-allowed;
  }

  svg {
    margin-right: -4px;
  }

  p {
    flex-shrink: 0;
    white-space: nowrap;
  }
`;

export const ExpandedFilterWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-column-gap: ${space('m')};
  grid-row-gap: ${space('s')};

  ${mq('m')} {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const FilterMeta = styled.div`
  display: flex;
  flex-direction: column;

  ${mq('m')} {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  & > div:last-of-type {
    display: flex;
    flex-direction: column;
    align-items: stretch;

    ${mq('s')} {
      display: flex;
      flex-direction: row;
      align-items: flex-end;
      align-self: flex-end;

      & > * + * {
        margin-left: ${space('s')};
      }
    }
  }
`;

export const FilterContent = styled.div`
  display: flex;
  flex-direction: column-reverse;

  & > * + *  {
    margin-bottom: ${space('s')};
  }
`;
